import { SkeletonBox } from '@practium/ui';
import styles from './BillingConversionFunnelChart.module.css';

export const BillingConversionFunnelChartSkeleton = () => (
	<>
		<div className={styles.skeletonInfo}>
			<SkeletonBox width="6rem" height="0.8rem" />
			<SkeletonBox width="4rem" height="1.25rem" />
			<SkeletonBox width="7rem" height="0.8rem" />
			<SkeletonBox width="9rem" height="0.8rem" />
		</div>
		<div className={styles.skeletonArea}>
			<SkeletonBox width="100%" height="100%" borderRadius="0.75rem" />
		</div>
		<div className={styles.skeletonStages}>
			{Array.from({ length: 3 }, (_, index) => (
				<div key={index} className={styles.skeletonStage}>
					<SkeletonBox width="100%" height="0.8rem" style={{ maxWidth: '7rem' }} />
					<SkeletonBox width="70%" height="0.8rem" style={{ maxWidth: '5rem' }} />
				</div>
			))}
		</div>
	</>
);
